import React, { Component } from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import { ACTIVITY_TYPE } from "../../../common/Constants";

class CrmTambahan extends Component {
  render() {
    const { options, activityType, controls, setValue, errors } = this.props;
    const isReadOnly =
      activityType !== ACTIVITY_TYPE.CREATE &&
      activityType !== ACTIVITY_TYPE.UPDATE;
    return (
      <>
        <div className="grid grid-3x gap-20px">
          <div id="grid-1">
            <SimpleInput
              name="hpNumber1"
              label="No HP 1"
              mandatory
              errorMessage={errors?.hpNumber1}
              value={controls?.hpNumber1?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="hpNumber2"
              label="No HP 2"
              value={controls?.hpNumber2?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="email"
              label="Email"
              mandatory={activityType === ACTIVITY_TYPE.CREATE}
              errorMessage={errors?.email}
              value={controls?.email?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="facebook"
              label="Facebook"
              value={controls?.facebook?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="instagram"
              label="Instagram"
              value={controls?.instagram?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="linkedin"
              label="LinkedIn"
              value={controls?.linkedin?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="twitter"
              label="X (Twitter)"
              value={controls?.twitter?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              name="tiktok"
              label="TikTok"
              value={controls?.tiktok?.value || null}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleDDL
              id="select_options_discCategory"
              box="search"
              name="discCategory"
              label="Kategori DISC"
              isClearable
              options={[
                { label: "DOMINANCE", value: "DOMINANCE" },
                { label: "INFLUENCE", value: "INFLUENCE" },
                { label: "STEADINESS", value: "STEADINESS" },
                { label: "COMPLIANCE", value: "COMPLIANCE" },
              ]}
              value={controls?.discCategory?.value || null}
              readOnly={isReadOnly}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>
          <div id="grid-2">
            <SimpleDDL
              id="select_options_hobby"
              box="multiselect"
              name="hobby"
              label="Hobby"
              options={options.hobbyOptions}
              value={controls?.hobby?.value || null}
              readOnly={isReadOnly}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>
          <div id="grid-3">
            <SimpleDDL
              id="select_options_interest"
              box="multiselect"
              name="interest"
              label="Interest"
              options={options.interestOptions}
              value={controls?.interest?.value || null}
              readOnly={isReadOnly}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>
        </div>
      </>
    );
  }
}

export default CrmTambahan;
